import { useTranslation } from 'react-i18next';
import useCrudMutation from 'hooks/useCrudMutation';
import { documentService } from 'domain/documents/api/documentService';
import { favoriteDocumentsQueryKey } from 'domain/documents/hooks/useGetFavoriteDocuments';

export default function useAddFavoriteDocument() {
  const { t } = useTranslation('genericItem');

  return useCrudMutation({
    mutationFn: documentService.addFavorite,
    successMessage: t('addFavoriteMessage'),
    errorMessage: t('failedToAddFavoriteMessage'),
    invalidateKeys: [[favoriteDocumentsQueryKey]],
  });
}
